import { render, staticRenderFns } from "./TheSideNavigation.vue?vue&type=template&id=190fff31&scoped=true&"
import script from "./TheSideNavigation.vue?vue&type=script&lang=js&"
export * from "./TheSideNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TheSideNavigation.vue?vue&type=style&index=0&id=190fff31&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190fff31",
  null
  
)

export default component.exports